import React from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import Arrow from '../../assets/img/arrow.svg';

const Button = styled.button`
	display: inline-block;
	background: #fcfcf5;
	color: #3f3d3d;
	font-weight: 600;
	border: 1px solid #858788;
	box-sizing: border-box;
	border-radius: 5px;
	padding: 12px 19px;
	position: relative;
	-moz-transition: 300ms ease-in-out;
	-webkit-transition: 300ms ease-in-out;
	transition: 300ms ease-in-out;

	&:after {
		content: '';
		display: block;
		position: absolute;
		border: 1px solid #858788;
		width: 100%;
		opacity: 0.5;
		height: 100%;
		border-radius: 5px;
		bottom: -10px;
		left: 8px;
		z-index: -1;
		-moz-transition: opacity 500ms ease-in-out;
		-webkit-transition: opacity 500ms ease-in-out;
		transition: opacity 500ms ease-in-out;
	}

	&:hover {
		// border-color: transparent;
		&:after {
			opacity: 0;
		}
		img {
			-webkit-transform: rotate(45deg);
			transform: rotate(45deg);
		}
	}

	img {
		display: inline-block;
		vertical-align: middle;
		margin-left: 10px;
		-moz-transition: 300ms ease-in-out;
		-webkit-transition: 300ms ease-in-out;
		transition: 300ms ease-in-out;
	}
`;

const GlobalButton = ({text, anchor}) => {
	return (
		<Link to={anchor}>
			<Button className="button">
				{text}
				<img src={Arrow} alt={`Go to ` + text} />
			</Button>
		</Link>
	);
};

export default GlobalButton;
